import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className='contact'>
        <div className="container wp_contact_wrap">
            <h1>Ready to discuss your project?</h1>
            <p>Whether you need a specialist MEP partner or a complete supply and
                installation solution — we want to hear from you.</p>
                <p>Phone Number - +971 4 289 6057</p>
                <p>Contact Us - admin@gemcomep.com</p>
                <a href="/contact-us" className='contact-btn'>Get In Touch</a>
        </div>
    </div>
  )
}

export default Contact